<template>
  <div class="logs">
    <div class="hander">
       <div class="hander1">
        <van-icon name="arrow-left" @click="goBack" class="nav_goback" />
      </div>
      
      <div class="date" @click="show=true">
        <span class="t1">{{ date }}</span>
        <div class="next">></div>
      </div>
      <span class="t2">支出:￥{{ exp }}</span>
    </div>
    <div
      class="scrollbox"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <div class="item" v-for="item in list" :key="item.id">
        <div class="bottom">
          <div class="left">
            <span class="t1">{{ item.type_title }}</span>
            <span class="t2">{{ item.add_time }}</span>
          </div>
          <span class="money">-{{ item.money }}</span>
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        @confirm="selDate"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>


<script>
import toTime from "../../assets/js/util";
export default {
  data() {
    return {
      show: false,
      currentDate: new Date(),
      date: "2019-08",
      list: [],
      page: 1,
      noData:false
    };
  },
  computed: {
    exp() {
      let list = this.list;
      let num = 0;
      list.forEach(item => (num += item.money * 100));
      return num / 100;
      return 0;
    }
  },
  created() {
    this.date = toTime.formatTimeTwo(new Date(), "Y-M");
    this.getList();
  },

  methods: {
    selDate(e) {
      let date = new Date(e);
      let year = date.getFullYear();
      let m = date.getMonth();
      let month = m > 8 ? m + 1 : '0' + (m + 1);
      this.noData = false
      this.page = 1
      this.date = year + "-" + month;
      this.getList()
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    getList() {
      this.$http({
        url: "consumptionList",
        data: {
          mouth: this.date,
          page: this.page
        }
      }).then(res => {
        if(!res._list.length){
          this.noData = true
        }else{
          let list = res.nowPage == 1? res._list:this.list.concat(res._list)
          this.list = list
          this.page +=1
        }
      });
    },
    loadMore() {
      if(this.noData) return
      this.loading = true;
      setTimeout(() => {
        this.page++
        this.getList()
        this.loading = false;
      }, 2500);
    }
  }
};
</script>
<style lang="less" scoped>
.logs {
    .hander1 {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    // background-color: rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
    color: #666;
    
  }
  .hander {
    width: 100%;
    height: 106px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .date {
      display: flex;
      align-items: center;
      color: #666;
      width: 200px;
      height: 60px;
      border-radius: 30px;
      .t1 {
        font-size: 30px;
      }
      .next {
        font-size: 30px;
        transform: scaleX(1.9) rotateZ(90deg);
        margin-left: 20px;
      }
    }
    .t2 {
      font-size: 24px;
      color: #666;
      flex: 1;
        text-align: right;
    }
  }
  .scrollbox {
    width: 100%;
    height: 100%;
  }
  .item {
    background-color: #fff;
    margin-bottom: 20px;
    .bottom {
      width: 100%;
      height: 125px;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        span {
          display: block;
        }
        .t1 {
          font-size: 30px;
          color: #333;
          margin-bottom: 10px;
        }
        .t2 {
          font-size: 24px;
          color: #999;
        }
      }
      .money {
        font-size: 30px;
        color: #e42129;
      }
    }
  }
}
</style>
